import { render, staticRenderFns } from "./controlePPM.vue?vue&type=template&id=4535247d&scoped=true&"
import script from "./controlePPM.vue?vue&type=script&lang=js&"
export * from "./controlePPM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4535247d",
  null
  
)

export default component.exports